import styled, { keyframes } from "styled-components";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const CustomizationWrap = styled.div`
  position: relative;
  
  &.saving {
    pointer-events: none;
    
    .customColorWrap,
    .themeWrap {
      opacity: 0.7;
    }
    
    .savingOverlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(255, 255, 255, 0.9);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10;
      border-radius: 17px;
      
      .savingContent {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 15px;
        padding: 30px;
        
        .bigSpinner {
          width: 40px;
          height: 40px;
          border: 4px solid rgba(34, 181, 115, 0.2);
          border-top: 4px solid #22B573;
          border-radius: 50%;
          animation: ${spin} 1s linear infinite;
        }
        
        span {
          font-size: 16px;
          font-weight: 500;
          color: #333;
        }
      }
    }
  }
  
  .customColorWrap {
    text-align: center;
    border: 1px dashed #cdcdcd;
    border-radius: 17px;
    padding: 30px 20px;
    margin-bottom: 30px;
    background-color: var(--white);
    
    .colorPickerSection {
      .title {
        display: block;
        font-size: 16px;
        line-height: 20px;
        font-weight: 400;
        margin-bottom: 10px;
        color: var(--text-color);
      }
      
      .description {
        display: block;
        font-size: 12px;
        line-height: 16px;
        font-weight: 300;
        margin-bottom: 20px;
        color: var(--text-light);
      }
      
      .colorInputWrap {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 15px;
        
        .colorPicker {
          width: 60px;
          height: 40px;
          border: none;
          border-radius: 10px;
          cursor: pointer;
          outline: none;
          box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15);
          transition: transform 0.2s ease;
          
          &:hover {
            transform: scale(1.05);
          }
        }
        
        .colorValue {
          font-size: 14px;
          font-weight: 500;
          color: var(--text-color);
          background-color: #f5f5f5;
          padding: 8px 12px;
          border-radius: 8px;
          border: 1px solid #e0e0e0;
          min-width: 80px;
          text-align: center;
        }
      }
    }
  }
  
  .themeWrap {
    width: 100%;
    padding: 20px;
    background-color: var(--white);
    border-radius: 15px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.11);
    min-height: 313px;
    
    .theme {
      margin-bottom: 20px;
      
      .title {
        display: block;
        font-size: 16px;
        line-height: 20px;
        font-weight: 400;
        margin-bottom: 20px;
      }
    }
    
    .primaryColor {
      .title {
        display: block;
        font-size: 16px;
        line-height: 20px;
        font-weight: 400;
        margin-bottom: 20px;
      }
    }
    
    .actionButtons {
      display: flex;
      gap: 15px;
      justify-content: center;
      margin-top: 30px;
      padding-top: 20px;
      border-top: 1px solid #e0e0e0;
      
      .saveBtn {
        background-color: var(--theme-primary, #22B573);
        color: white;
        border: none;
        min-width: 140px;
        position: relative;
        
        &:hover:not(:disabled) {
          opacity: 0.9;
        }
        
        &:disabled {
          opacity: 0.8;
          cursor: not-allowed;
        }
        
        .loadingContent {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          
          .spinner {
            width: 16px;
            height: 16px;
            border: 2px solid rgba(255, 255, 255, 0.3);
            border-top: 2px solid white;
            border-radius: 50%;
            animation: ${spin} 1s linear infinite;
          }
        }
      }
      
      .discardBtn {
        background-color: transparent;
        color: var(--theme-primary, #22B573);
        border: 1px solid var(--theme-primary, #22B573);
        min-width: 120px;
        
        &:hover:not(:disabled) {
          background-color: var(--theme-primary-50, rgba(34, 181, 115, 0.1));
        }
        
        &:disabled {
          opacity: 0.5;
          cursor: not-allowed;
          color: #999;
          border-color: #999;
        }
      }
    }
    
    .dropdownWrap {
      position: relative;
      width: 100%;
      
      .dropdown {
        cursor: pointer;
        display: flex;
        gap: 5px;
        align-items: center;
        justify-content: space-between;
        background-color: #f0f2f3;
        border-radius: 8px;
        padding: 10px 14px;
        height: 45px;
        font-size: 14px;
        font-weight: 600;
        color: var(--text-color);
        border: 1px solid transparent;
        transition: all 0.3s ease;
        
        &:hover {
          border: 1px solid var(--primary);
        }
        
        .icon {
          font-size: 16px;
          color: var(--text-color);
        }
      }
      
      .dropdownList {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: var(--white);
        border-radius: 8px;
        box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.1);
        z-index: 10;
        overflow: hidden;
        
        .dropdownItem {
          padding: 10px 14px;
          font-size: 14px;
          font-weight: 600;
          color: var(--text-color);
          cursor: pointer;
          transition: all 0.3s ease;
          
          &:hover {
            background: var(--primary-50);
          }
        }
      }
    }
  }
`;

export const SelectorWrapper = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

export const RadioLabel = styled.label`
  cursor: pointer;
`;

export const RadioInput = styled.input`
  display: none;
`;

export const ColorButton = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  cursor: pointer;
  position: relative;
  border: 2px solid transparent;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    transform: scale(1.1);
    border-color: rgba(0, 0, 0, 0.2);
  }
`;

export const Checkmark = styled.img`
  width: 16px;
  height: 16px;
`;

export const DropDown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: var(--white);
  border-radius: 8px;
  box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.1);
  z-index: 10;
  overflow: hidden;
  
  .dropdownItem {
    padding: 10px 14px;
    font-size: 14px;
    font-weight: 600;
    color: var(--text-color);
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
      background: var(--primary-50);
    }
  }
`;
